import React from 'react';
import { Typography, Space, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { EnterpriseTokens } from '@/theme/enterprise-tokens';

const { Title, Text } = Typography;

export interface ExecutiveHeaderProps {
  displayName: string;
  companyName?: string;
  updatedAt: Date | null;
  loading: boolean;
  onRefresh: () => void;
}

export const ExecutiveHeader: React.FC<ExecutiveHeaderProps> = ({
  displayName,
  companyName,
  updatedAt,
  loading,
  onRefresh,
}) => {
  const dateLabel = updatedAt
    ? updatedAt.toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : null;

  return (
    <div
      style={{
        marginBottom: EnterpriseTokens.spacing.xl,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        gap: EnterpriseTokens.spacing.lg,
      }}
    >
      <div>
        <Title level={2} style={{ marginBottom: EnterpriseTokens.spacing.sm, ...EnterpriseTokens.typography.objectTitle }}>
          Welcome, {displayName}
        </Title>
        <Text type="secondary" style={{ fontSize: 14, display: 'block' }}>
          {companyName ? `${companyName} · ` : ''}
          Executive overview — operational health, exceptions, and entry points to each domain.
        </Text>
        {dateLabel && (
          <Text type="secondary" style={{ fontSize: 12, display: 'block', marginTop: 8 }}>
            Last updated: {dateLabel}
          </Text>
        )}
      </div>
      <Space>
        <Button icon={<ReloadOutlined />} onClick={onRefresh} loading={loading}>
          Refresh
        </Button>
      </Space>
    </div>
  );
};
